import React from "react"
import moment from "moment"

export default ({ value }) => {
  try {
    const date = moment(value)

    return (
      <span className="format-date" title={moment(date).local().format()}>
        {value && date.format("Do MMMM YYYY")}
      </span>
    )
  } catch (ex) {
    return <span>Data invalid.</span>
  }
}
